import { Form, PageHeader, Row, Col, Input, Button, Select, Space, Divider, Descriptions, DatePicker } from 'antd'
import {UserAddOutlined} from '@ant-design/icons'
import apis from "../../services/apis"
import React, { useEffect, useState, useRef } from 'react'
import ReactToPrint from "react-to-print";
import { v4 as uuid } from 'uuid';
import { useApiContext } from "../../hooks/useApiContext";
import { dateFormat } from "../../utils/Constants";
import SalaryPrint from '../../components/salary/SalaryPrint';

export default function AddSalary() {
  const { Option } = Select;
  let printRef = useRef();
  const [getFixed, setGetFixed] = useState(false)
  const [attandays, setAttandays] = useState(0)
  const [absent, setAbsent] = useState(false)
  const [overTimeHours, setOverTimeHours] = useState(0)
  const [overTimeHoursCost, setOverTimeHoursCost] = useState(0)
  const [advanceAmount, setAdvanceAmount] = useState(0)
  const [calculateSalaryAmount, setCalculateSalaryAmount] = useState(0)
  const [getEmployee, setGetEmployee] = useState()
  const [basicsalary, setBasicsalary] = useState()
  const [salaryDate, setSalaryDate] = useState()
  const [print, setPrint] = useState(true)
  const [isSave, setIsSave] = useState(false)
  const [deductions, setDeductions] = useState(0)
  const [workingDays, setWorkingDays] = useState()
    

  const {  employeedispatch, employee, salarydispatch} = useApiContext()
    useEffect(()=>{
        if(employee.length<1) apis.Employees.list(employeedispatch)
    },[employee.length<1])

    const onFinish = (values) => {
      let newValues ={...values, id:uuid(), totalAmount:calculateSalaryAmount, paymentDate: salaryDate, bonusAmount: getFixed ? 100 : 0}
      apis.Salaries.create(salarydispatch, newValues).then(()=>{
        setIsSave(true)
        setPrint(true)
      })
        console.log("Success:", newValues);
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
      };

      const getEmployeeDetails =(value) =>{
        setGetEmployee(employee.find(x=>x.id ==value))
      }

      console.log("employee details", getEmployee);

      const getFixedValue=(value)=>{
        setWorkingDays(value.target.value)
        setGetFixed(false)
       setAbsent(false)
        if(value.target.value == "26"){
            setGetFixed(true)
        }
        if(value.target.value < "26")
        {
            setAttandays(value.target.value)
            setAbsent(true)
        }
    }

    const calculateSalary=()=>{
      let overtimeamount = (overTimeHours * overTimeHoursCost)
      let removals = Number(advanceAmount) + Number(deductions)
      console.log("removals amount", removals);
      if(getFixed)
      {
        console.log("basics salary", basicsalary);
        console.log("overtimehours", overTimeHours);
        console.log("overTimeHoursCost", overTimeHoursCost);

       
        if(basicsalary){
          let sumvalue= Number(basicsalary)+ 100 + overtimeamount - removals
          console.log("sum value", sumvalue);
          setCalculateSalaryAmount(sumvalue)
        } 
        else{

          let sumvalue= Number(getEmployee?.basicSalary)+ 100 + overtimeamount- removals
          console.log("sum value", sumvalue);
          setCalculateSalaryAmount(sumvalue)
        }
     
      }
      else{
        setCalculateSalaryAmount(Number(getEmployee?.basicSalary ? getEmployee?.basicSalary : basicsalary)+ overtimeamount - removals)
      }
    }

  return (
    <>
         <PageHeader
    className="site-page-header"
    onBack={() => null}
    title="Salaries"
    subTitle="Find all the list of salaries here"
    
  />
     <Form
       name="basic"
       labelCol={{
         span: 8,
       }}
       wrapperCol={{
         span: 16,
       }}
       initialValues={{
         remember: true,
       }}
       onFinish={onFinish} 
       onFinishFailed={onFinishFailed}
       autoComplete="off"
     >
          <Row style={{marginTop:'40px'}}>
         <Col span={12}>
         <Form.Item
             label="Select Employee"
             name="employeeId"
             rules={[
               {
                 required: true,
                 message: "Please input your employee name",
               },
             ]}
           >
            <Select   placeholder="Select Employee" showSearch 
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={getEmployeeDetails}
            >
                {employee && employee.map((employee) =>(
                    <Option value={employee.id}>{employee.fullName}</Option>
                ))}
   </Select>
           </Form.Item>
           {getEmployee && getEmployee.basicSalary == 0 ? 
              <Form.Item
              label="Enter basic salary"
              name="basicSalary"
              rules={[
                {
                  required: true,
                  message: "Please input your employee name",
                },
              ]}
            >
              <Input onChange={(e)=> setBasicsalary(e.target.value)}/>
            </Form.Item> 
            :
            ""
          }
     <Form.Item
                label="Month of salary"
                name="paymentDate"
                rules={[
                  {
                    required: true,
                    message: "Please input your employee name",
                  },
                ]}
              >
  
                <DatePicker
                  placeholder="DD/MM/YYYY"
                  format={dateFormat}
                  onChange={(datestring) => setSalaryDate(datestring.format(dateFormat))}
                  style={{width:'100%'}}
                />
              </Form.Item>
           <Form.Item
             label="Total Working Days"
             name="totalAttendence"
             rules={[
               {
                 required: true,
                 message: "Please input your employee name",
               },
             ]}
           >
             <Input onChange={getFixedValue}/>
           </Form.Item>
           <Form.Item
             label="Overtime Hours"
             name="overTimeHours"
             rules={[
               {
                 required: true,
                 message: "Please input your employee name",
               },
             ]}
           >
             <Input onChange={(e)=>setOverTimeHours(e.target.value)}/>
           </Form.Item>
           <Form.Item
             label="OverTime Cost/hr"
             name="overTimeCost"
             rules={[
               {
                 required: true,
                 message: "Please input your employee name",
               },
             ]}
           >
             <Input onChange={(e)=> setOverTimeHoursCost(e.target.value)}/>
           </Form.Item>
           <Form.Item
             label="Advance Amount"
             name="advanceAmount"
             rules={[
               {
                 required: true,
                 message: "Please input your employee name",
               },
             ]}
           >
             <Input onChange={(e)=>setAdvanceAmount(e.target.value)}/>
           </Form.Item>
           <Form.Item
             label="Deductions"
             name="deductions"
             rules={[
               {
                 required: true,
                 message: "Please input your employee name",
               },
             ]}
           >
             <Input type="number" onChange={(e)=>setDeductions(e.target.value)} />
           </Form.Item>
          <Form.Item  wrapperCol={{ offset: 8, span: 16 }}>
           
          <Button type="primary" onClick={calculateSalary}  icon={<UserAddOutlined />} style={{marginRight:'5px'}}>
         Calculate Salary 
       </Button>
             <label> Total Salary Amount : {calculateSalaryAmount}</label>
          </Form.Item>
           <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
             {calculateSalaryAmount != 0 &&   <Button type="primary" disabled={isSave} htmlType="submit" icon={<UserAddOutlined />} style={{marginRight:'5px'}}>
         Add Salary 
       </Button> }
      
      {print && <ReactToPrint trigger={() => <Button type='primary'>Print</Button> } content={() => printRef.current} />}
             
              
             
       </Form.Item>
         </Col>
         <Col span={12}>
         {getEmployee && 
         <>
           <Descriptions style={{marginLeft:'15px'}} title="Employee Details" bordered>
           <Descriptions.Item label="Employee Id" span={2}>{getEmployee.empId}</Descriptions.Item>
           <Descriptions.Item label="Basic Salary" span={2}>{getEmployee.basicSalary}</Descriptions.Item>
           <Descriptions.Item label="Project" span={2}>{getEmployee.project?.projectName}</Descriptions.Item>
           <Descriptions.Item label="Leave policy" span={2}>{getEmployee.leavePolicy}</Descriptions.Item>
           {getFixed &&
           <>
            <Descriptions.Item label="Attendence Bonus" span={2}>100</Descriptions.Item>
            
            </>
            }
            {absent && <Descriptions.Item label="Absent" span={2}>{26 - attandays}</Descriptions.Item>}
              
               </Descriptions>
            
         </>
         }
          
         </Col>
         </Row>
     </Form>   
     <div style={{display:'none'}}>
       {
         getEmployee && 

         <SalaryPrint
          basicsalary={getEmployee?.basicSalary ? getEmployee?.basicSalary : basicsalary} 
          empId={getEmployee.empId}
          employeeName={getEmployee.fullName}
          workingDays={workingDays}
          borderNumber={getEmployee.borderNumber}
          projectName={getEmployee.project?.projectName}
          salaryDate={salaryDate} 
          overTimeHours={overTimeHours}
          overTimeHoursCost={overTimeHoursCost}
          getFixed={getFixed? 100 :0}
          advanceAmount={advanceAmount}
          deductions={deductions}
          calculateSalaryAmount={calculateSalaryAmount}
          ref={printRef}/>
       }
         
      </div>
    </>
  )
}
